import { recipe } from "@vanilla-extract/recipes";
import { rem } from "@huub-web/utils/css/rem";

import { responsive } from "../../utils/responsive";
import { alignVariants } from "../../utils/vanilla/alignVariants";

export const logoStyle = recipe({
  base: {
    objectFit: "contain",
  },
  variants: {
    size: {
      s: { height: rem(22) },
      m: { height: rem(28) },
      l: { height: rem(38) },
      xl: { height: rem(46) },
      header: {
        height: rem(24),
        ...responsive({
          s: {
            height: rem(36),
          },
        }),
      },
    },
    alignSelf: alignVariants("alignSelf"),
  },
  defaultVariants: {
    size: "m",
  },
});
